import { useWebSocket } from "WebSocketContext";
import { useGameContext } from "GameContext";
import {
  useState,
  useEffect,
} from "react";
import { allRoles } from "utils/game-information-constants";
import PillButton from "components/General/PillButton";

function RoleButton({
  role,
  changeRole,
  disabled=false,
}: {
  role: {
    role: string,
    estate: string,
    description: string,
    color: string,
  },
  changeRole: (_: string) => void;
  disabled?: boolean;
}) {
  return (
    <button className={`p-2 text-left space-y-2 border border-black ${!disabled ? "opacity-100" : "opacity-30"}`}
      style={{
        backgroundColor: role.color,
      }}
      onClick={() => changeRole(role.role)}
      disabled={disabled}
    >
      <label>{role.role}</label>
      <p>{role.description}</p>
    </button>
  )
}

export default function RoleSelector({
  customSelectRole,
  onSelectRole = () => null,
}: {
  customSelectRole?: (estate: string, role: string) => void;
  onSelectRole?: (role: string) => void;
}) {
  const { playerId, socket } = useWebSocket();

  const {
    gameId,
    connectedIds,
    amJoiningMidGame,
    players,
  } = useGameContext() as any;

  function changeRole(role: string) {
    const estateRole = currentTab === 0 ? "public" : "private"

    if (customSelectRole) {
      customSelectRole(estateRole, role)
      return;
    }

    const mes = JSON.stringify({
      kind: "UpdatePlayerInfo",
      toIds: connectedIds,
      playerId: playerId,
      newData: {
        role: role,
        estate: estateRole,
      }
    })
    socket?.send( mes );
    onSelectRole(role);
  }


  const [availablePublicRoles, setAvailblePublicRoles] = useState<string[]>([]);
  const [availablePrivateRoles, setAvailablePrivateRoles]  = useState<string[]>([]);

  useEffect(() => {
    if (amJoiningMidGame) {
      const availablePubRoles: string[] = []
      const availablePrivRoles: string[] = []

      for (let i=0; i < players.length; i++) {
        const plyInfo = players[i];

        if (!plyInfo?.estate || !plyInfo?.role) {
          continue
        }

        const key = `${plyInfo.estate}-${plyInfo.role}`

        if (plyInfo.estate === "public") {
          if (!availablePubRoles.includes(key)) {
            availablePubRoles.push(plyInfo.role);
          }
        } else if (plyInfo.estate === "private") {
          if (!availablePrivRoles.includes(key)) {
            availablePrivRoles.push(plyInfo.role);
          }
        }
      }

      setAvailblePublicRoles(availablePubRoles)
      setAvailablePrivateRoles(availablePrivRoles)
    }
  }, [amJoiningMidGame, players])

  const [currentTab, setCurrentTab] = useState(0);

  return (
    <div className="flex flex-col items-center space-y-4 p-2 max-w-[800px]">
      <div className="flex flex-row gap-2 w-full">
        <PillButton
          text={"Public"}
          selected={currentTab === 0}
          onClick={() => {
            setCurrentTab(0);
          }}
        />
        
        <PillButton
          text={"Private"}
          selected={currentTab === 1}
          onClick={() => {
            setCurrentTab(1);
          }}
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        { allRoles.map((role, i) => {
          let amDisabled = false;
          if (amJoiningMidGame) {
            if (role.estate === "public" && !availablePublicRoles.includes(role.role) ){
              amDisabled = true;
            }
            if (role.estate === "private" && !availablePrivateRoles.includes(role.role) ){
              amDisabled = true;
            }
          }

          if (currentTab === 0 && role.estate === "public") {
            return (
              <RoleButton key={i} role={role} changeRole={changeRole}
                disabled={amDisabled}
              />
            )
          } else if (currentTab === 1 && role.estate === "private") {
            return (
              <RoleButton key={i} role={role} changeRole={changeRole}
                disabled={amDisabled}
              />
            )
          }

          return null
        })}
      </div>
    </div>
  )
}
